import { decryptFromStore, encrypt } from '../util/crypto'
import fp from '../util/fingerprint'

export const Session = {
  user: {},
  token: null,
  state: false,
  subscription: true,
  gracePeriod: true,
  subscriptionTimeOut: null,
  needsAuth: false,
  localStorageKey: 'STORYLABS2025',
  counter: null,
  communityCounter: 3,
  facturaCounter: 1520,
  microCounter: 70,
  proCounter: 2500, // Plan PYMES. PRO
  fullCounter: 999999,
  appOptions: [
    {
      name: 'premium',
      roles: ['MICRO', 'PRO', 'FULL']
    },
    {
      name: 'billable',
      roles: ['MICRO', 'PRO', 'FACTURA', 'FULL']
    },
    {
      name: 'community',
      roles: ['COMMUNITY']
    },
    {
      name: 'all',
      roles: ['MICRO', 'PRO', 'COMMUNITY', 'FACTURA', 'FULL']
    }
  ],

  getAppOptions(opt) {
    const option = this.appOptions.find(o => o.name === opt && o.roles.includes(this.user.profile))
    return !!option
  },

  getCurrentCounter() {
    const max =
      this.user.profile === 'COMMUNITY'
        ? this.communityCounter
        : this.user.profile === 'MICRO'
        ? this.microCounter
        : this.user.profile === 'FACTURA'
        ? this.facturaCounter
        : this.user.profile === 'FULL'
        ? this.fullCounter
        : this.user.profile === 'PRO'
        ? this.proCounter
        : this.communityCounter

    return max - this.counter
  },
  end() {
    this.user = {}

    this.needsAuth = false
    this.state = false
    this.token = null

    localStorage.removeItem(this.localStorageKey)
  },
  setAuth(val) {
    this.needsAuth = val
  },
  set(val) {
    const { id, email, fullname, state, tel, token, profile, subprofile, domain, roles, createdAt, crmRole, viajesRole } = val

    if (token) this.setToken(token)
    this.setAuth(false)

    this.user = { id, email, fullname, state, tel, profile, domain, roles, subprofile, createdAt, crmRole, viajesRole }
  },
  setSubscription(val, grace = false, subscriptionTimeOut) {
    this.subscription = val
    if (grace) {
      this.gracePeriod = true
      this.subscriptionTimeOut = subscriptionTimeOut
    } else {
      this.gracePeriod = false
    }
  },
  setCounter(val) {
    this.counter = val
  },
  substractCounter() {
    this.counter = this.counter + 1
  },
  setProfile(val) {
    this.user.profile = val
  },
  async setToken(t) {
    this.token = t
    await this.isValid()

    const fingerprint = await fp.get()
    const encryptedData = await encrypt(t, fingerprint, this.localStorageKey)

    console.log('User Token Encrypted  🔒 :>> ', encryptedData)
    if (!encryptedData) localStorage.removeItem(this.localStorageKey)
  },
  async getToken() {
    let localToken = null

    if (!this.token) {
      console.log('decrypting token... wait 🫣')
      console.time('getToken')

      const fingerprint = await fp.get()

      localToken = (await decryptFromStore(this.localStorageKey, fingerprint)) || null

      if (localToken) {
        this.token = localToken
      }

      console.timeEnd('getToken')

      return localToken
    }

    return this.token
  },

  async isValid() {
    let currentState = false
    const t = await this.getToken()

    if (t) {
      const { exp } = JSON.parse(Buffer.from(t.split('.')[1], 'base64').toString('ascii'))
      const currentTime = new Date().getTime() / 1000
      if (parseInt(currentTime) <= parseInt(exp)) currentState = true
    }
    this.state = currentState

    return this.state
  }
}

export default async ({ app, redirect }, inject) => {
  inject('session', Session)

  if (process.browser) {
    console.log('Starting Session 🚀')
    if (await app.$session.isValid()) {
      const token = await app.$session.getToken()
      const tokenValues = JSON.parse(atob(token.split('.')[1]))

      const { id, email, fullname, profile, subprofile, domain, roles, createdAt, crmRole, viajesRole } = tokenValues

      app.$session.set({ id, email, fullname, profile, subprofile, domain, roles, createdAt, crmRole, viajesRole })

      console.log('Fast user session ⚡ ', app.$session.user.email)
      console.log('loggedIn 🤩')
    } else {
      console.log('not logged in 🤨')
    }
  }
}
